// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"189":"editor","340":"campaigns","392":"ControlPanel","493":"preview"}[chunkId] + "." + {"189":"6ae5520d","340":"1d6fe902","392":"e2596e5e","493":"5da10b05"}[chunkId] + ".js";
};